module.exports = __webpack_public_path__ + "static/media/frigonekretnine.com.5d2e3c52.png";